import { twMerge } from 'tailwind-merge';

type Props = {
  className?: string;
};

export function Skeleton({ className }: Props): React.ReactElement {
  const finalClasses = twMerge('h-2.5 bg-gray-300 rounded-sm w-48', className);

  return (
    <div role="status" className="max-w-sm animate-pulse">
      <div className={finalClasses}></div>
      <span className="sr-only">Loading...</span>
    </div>
  );
}
